import React from 'react';
import PropTypes from 'prop-types';
import NHFetch from '../../utils/NHFetch.js';

import _Gauge from './LeftTopBox/_Gauge';
import _StackedBar from './LeftTopBox/_StackedBar';
import _Radar from './LeftTopBox/_Radar';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 15 * 1000; //轮询时间间隔

/**
 * * 环节办理统计图
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-09-12
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            data: [] //环节办理统计数据
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 获取环节办理统计数据
     * @memberof Home
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/sstj/getLinkHandlingStatistics', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: 0, data: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    }

    /**
     * * 根据数据量构造相应的统计图
     * @memberof IndexComponent
     */
    buildChartsOption = () => {

        const { data = [] } = this.state;
        const { rem } = this.props;

        if (data.length <= 1) {
            return <_Gauge rem={rem} dataSource={data}/>
        } else if (data.length > 1 && data.length <= 3 ) {
            return <_StackedBar rem={rem} dataSource={data}/>
        } else if (data.length > 3) {
            return <_Radar rem={rem} dataSource={data}/>
        }
    };

    render() {
        return (this.buildChartsOption())
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-zzsd/_LeftTopBox.js